import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getSubLessonBySearch } from "../../services/SubLesson";
import { TitleBar } from "../../components/TitleBar";
import Cookies from "js-cookie";
import useAuth from "../../hook/useAuth";
import { getLessonById } from "../../services/Lesson";
import useSearch from "../../hook/useSearch";


export const SearchResult = () => {
    const navigate = useNavigate();
    const { setIsSearchFocused, setShowMobileSearch, searchValue, setSearchValue }: any = useSearch();
    const token = Cookies.get("token-elministry");
    const { auth }: any = useAuth();
    const [allSearchData, setAllSearchData] = useState<any[]>([]);
    const [searchDataLoaded, setSearchDataLoaded] = useState<boolean>(false);
    const [page, setPage] = useState(1);
    const size = 5; // ✅ fixed page size
    const [totalPages, setTotalPages] = useState(1);

    const fetchSearchResults = async (pageNum: number) => {
        setSearchDataLoaded(false);
        try {

            const data = await getSubLessonBySearch(searchValue.trim(), pageNum, size);

            if (data && Array.isArray(data.subLessons)) {
                const updatedData = await Promise.all(
                    data.subLessons.map(async (item: any) => {
                        if (item.lessonId) {
                            try {
                                const lessonRes = await getLessonById(item.lessonId);
                                return { ...item, courseId: lessonRes.courseId };
                            } catch (error) {
                                console.error(`Failed to fetch lesson for id ${item.lessonId}`, error);
                                return { ...item, courseId: null };
                            }
                        }
                        return item;
                    })
                );

                setAllSearchData(updatedData);
                setTotalPages(Math.ceil(data.count / size));
            } else {
                setAllSearchData([]);
                setTotalPages(1);
            }
        } catch (error) {
            console.error(error);
            setAllSearchData([]);
        } finally {
            setSearchDataLoaded(true);
        }
    };

    useEffect(() => {
        if (searchValue) {
            fetchSearchResults(page - 1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue, page]);


    const Pagination = () => {
        const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

        return (
            <div className="flex items-center justify-center gap-2 mt-6 flex-wrap">
                <button
                    onClick={() => setPage((p) => Math.max(1, p - 1))}
                    disabled={page === 1}
                    className={`px-3 py-1 rounded-md border text-sm font-medium ${page === 1
                        ? "text-gray-400 bg-gray-100 cursor-not-allowed"
                        : "bg-white text-gray-600 border-gray-300 hover:bg-gray-100"
                        }`}
                >
                    Previous
                </button>

                {pages.map((num) => (
                    <button
                        key={num}
                        onClick={() => setPage(num)}
                        className={`px-3 py-1 rounded-md border text-sm font-medium transition ${num === page
                            ? "bg-primary text-white border-primary"
                            : "bg-white text-gray-600 border-gray-300 hover:bg-gray-100"
                            }`}
                    >
                        {num}
                    </button>
                ))}

                <button
                    onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                    disabled={page === totalPages}
                    className={`px-3 py-1 rounded-md border text-sm font-medium ${page === totalPages
                        ? "text-gray-400 bg-gray-100 cursor-not-allowed"
                        : "bg-white text-gray-600 border-gray-300 hover:bg-gray-100"
                        }`}
                >
                    Next
                </button>
            </div>
        );
    };

    const highlightMatch = (text: string, query: string) => {
        if (!query) return text;

        const regex = new RegExp(`(${query})`, "gi");
        return text.split(regex).map((part, i) =>
            regex.test(part) ? (
                <span key={i} className="bg-yellow-400 font-semibold">
                    {part}
                </span>
            ) : (
                part
            )
        );
    };

    return (
        <div className="max-md:px-4 px-12 py-4">
            <TitleBar
                title="Search results"
            />

            <div className="space-y-4 py-8 min-h-[60vh]">

                {
                    (searchDataLoaded && allSearchData.length > 0) && (
                        <>
                            {allSearchData?.map((item: any, index: number) => (
                                <div
                                    key={index}
                                    className="flex items-center justify-between bg-white shadow rounded-lg p-4 border hover:bg-gray-100 hover:shadow-md transition cursor-pointer"
                                    onClick={() => {
                                        setSearchValue("");
                                        setIsSearchFocused(false);
                                        setShowMobileSearch(false);
                                        navigate("/course-lesson", {
                                            state: {
                                                courseId: item.courseId,
                                                subLessonId: item.id,
                                                lessonId: item.lessonId,
                                                isLogin: token ? true : false,
                                                isLearner: auth?.role === "Learner" ? true : false,
                                            },
                                        })
                                    }}>
                                    <div className="flex space-x-4">
                                        <img src="/images/class-img.png" alt="class-img" className="w-16 h-16 rounded-md" />
                                        <div className="space-y-2">
                                            <h3 className="font-semibold text-primary uppercase">
                                                {highlightMatch(item?.title, searchValue)}
                                            </h3>

                                            <p className="text-sm text-gray-500">
                                                {highlightMatch(item?.description, searchValue)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            <Pagination />
                        </>


                    )
                }

                {
                    !searchDataLoaded && (
                        <div className="flex items-center justify-center w-full p-2 min-h-full">
                            <div className="mb-4 h-16 w-16 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                        </div>
                    )
                }

                {
                    (searchDataLoaded && allSearchData.length === 0) && (
                        <div className="flex items-center justify-center w-full p-2 min-h-full">
                            <span className="text-lg text-gray-400">No results found!</span>
                        </div>
                    )
                }

            </div>

        </div>
    )
}